import { LabelsMap } from 'new/form/common/types';

export const companySearchSectionLabelsMap: LabelsMap = {};
